// extracted by mini-css-extract-plugin
module.exports = {"inboxButton":"styles_inboxButton__3VmbO","unreadBadge":"styles_unreadBadge__28ewZ","modalContent":"styles_modalContent__2z6Hk","modal":"styles_modal__3_Ypf"};